import {createSelector} from 'reselect';
import {itgProcess} from './itgProcess';

export const processSessionId = createSelector(
  itgProcess,
  itgProcess => itgProcess.sessionId
);
